import React, { useEffect, useState } from "react";
import { Layout } from "shared/utils";
import dayjs from "dayjs";
import "dayjs/locale/es";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Box,
  Button,
  ClickAwayListener,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./styles/autorizationPayments.module.scss";
import "../read-documents/styles/_menuFunctions.scss";
import "shared/components/paginator/styles/_filterSearchOrder.scss";
import tableStyles from "../read-documents/styles/tableResults.module.scss";
import { FormFilter } from "../../shared/components/form-filter/FormFilter";
import useAutorizationPayments from "./hooks/useAutorizationPayments";
import { useWidth } from "shared/hooks/HookDetailedConsultation/useWidth";
import { accesRoles, Dispatch, GET_ELECTRONIC_DOCS, Spinner } from "shared";
import { ButtonAction } from "shared/components";
import { ModalStatesPayments } from "./components/ModalStatesPayments";
import { useHookFormAutorization } from "./hooks";
import { TableCollapseAutorizations } from "./components/TableCollapseAutorizations";
import { ModalSeguimientoCuentas } from "./components/ModalSeguimientoCuentas";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const AutorizationPayments = () => {
  const [openOptions, setOpenOptions] = useState(false);
  const [openSeguimiento, setOpenSeguimiento] = useState(false);

  const handleToggleOptions = () => setOpenOptions((prev) => !prev);
  const handleCloseOptions = () => setOpenOptions(false);
  const handleOpenSeguimiento = () => {
    handleCloseOptions();
    setOpenSeguimiento(true);
  };
  const handleNavigateDeductions = () => {
    handleCloseOptions();
    navigate("/autorizaciones/gestion-deducciones");
  };
  const handleNavigateCostCenter = () => {
    handleCloseOptions();
    navigate("/autorizaciones/administrar-centro-costo");
  };
  useEffect(() => {
    dayjs.locale("es");
  }, []);

  const {
    columns,
    valuesResultsPages,
    rowSelected,
    rowContentSelected,
    handleSelectAllClick,
    handleChangeCheck,
    hasContract,
    handleChangeContract,
    showForm,
    setShowForm,
    summationRows,
    dataFields,
    isLoading,
    getPayment,
    showBtnInitiatePayment,
    showBtnGenerateCertificate,
    onGenerateCertificate,
    providers,
    providersPage,
    providersSize,
    setProvidersPage,
    setProvidersSize,
    providerInvoices,
    providerInvoicesPage,
    providerInvoicesSize,
    providerInvoicesLoading,
    getProviderInvoices,
    setProviderInvoicesPage,
    setProviderInvoicesSize,
    appliedFilters,
    setAppliedFilters,
  } = useAutorizationPayments();

  const {
    handleSubmit,
    handleChange,
    getValueDatePickerStart,
    getValueDatePickerEnd,
    maxDate,
    handleUserAssignment,
    validateActivitiesSelected,
    onCloseModal,
    openModalStates,
    statesSelected,
    values,
    selectAllActivies,
    onSelected,
    onChangesDatePicker,
    inputFieldState,
    handleClear,
  } = useHookFormAutorization(hasContract, setShowForm, setAppliedFilters);

  const { width } = useWidth();
  const dispatch = useDispatch<Dispatch>();
  const navigate = useNavigate();

  const contractTabValue = hasContract ? "true" : "false";

  const handleToggleFilters = () => {
    setShowForm((prev) => !prev);
  };

  const handleTabsChange = (_event: React.SyntheticEvent, value: string) => {
    if (value !== contractTabValue) {
      handleChangeContract(value === "true");
    }
  };

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(3);
    getPayment(`${GET_ELECTRONIC_DOCS}/page_payments`, {
      states: "",
      isContract: hasContract,
      orderBy: "1",
      size: 50,
    });

    return () => {
      dispatch.electronicDocuments.cleanState();
      dispatch.summationRows.setSummationRows([
        { name: "Recuento", value: "0" },
        { name: "Total facturas seleccionadas", value: "0" },
        { name: "Total", value: "0" },
      ]);
    };
  }, []);

  return (
    <Layout>
      <section className={styles.contentAutorizationPayment}>
        <Box className={`${styles.header} ${styles.headerWithBorder}`}>
          <Typography className="titleMainLayout">
            Facturas candidatas para pagos
          </Typography>
          <Box className={styles.headerRight}>
            <Box className={styles.tabsAndSearch}>
              <Box
                className={`${tableStyles.searchContainer} ${styles.searchContainer}`}
              >
                <span
                  className={`${tableStyles.searchItems} ${styles.searchItems}`}
                >
                  <div
                    className={`padding-search ${styles.searchBox} ${
                      showForm ? styles.searchBoxActive : ""
                    }`}
                    role="button"
                    tabIndex={0}
                    onClick={handleToggleFilters}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        handleToggleFilters();
                      }
                    }}
                    data-testid="btn-filters-autorization"
                  >
                    <div className="contenido-autocomplete">
                      <SearchIcon className="icono-buscar" />
                      <TextField
                        className="inputText"
                        variant="outlined"
                        fullWidth
                        value={showForm ? "Ocultar filtros" : ""}
                        placeholder="Buscar"
                        inputProps={{ readOnly: true }}
                        onFocus={(event) => event.target.blur()}
                        sx={{
                          "& .MuiInputBase-input": {
                            color:
                              "rgba(var(--general-color-r), var(--general-color-g), var(--general-color-b), 1)",
                            fontSize: "14px",
                          },
                          "& .MuiOutlinedInput-input::placeholder": {
                            color:
                              "rgba(var(--general-color-r), var(--general-color-g), var(--general-color-b), 1)",
                            opacity: 1,
                          },
                        }}
                      />
                    </div>
                  </div>
                </span>
              </Box>
              <Tabs
                value={contractTabValue}
                onChange={handleTabsChange}
                className={styles.contractTabs}
                aria-label="Filtro por contrato"
                data-testid="toogle-filter-contract"
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
              >
                <Tab value="false" label="Sin contrato" disableRipple />
                <Tab value="true" label="Con contrato" disableRipple />
              </Tabs>
            </Box>
            <ClickAwayListener onClickAway={handleCloseOptions}>
              <Box className={styles.optionsWrapper}>
                <IconButton
                  onClick={handleToggleOptions}
                  sx={{
                    color:
                      "rgba(var(--general-color-r), var(--general-color-g), var(--general-color-b), 1)",
                  }}
                  data-testid="btn-options-autorization"
                >
                  <MoreVertIcon />
                </IconButton>
                {openOptions && (
                  <Paper
                    className="menuOptions"
                    elevation={3}
                    sx={{
                      position: "absolute",
                      right: 0,
                      top: "100%",
                      zIndex: 1300,
                      minWidth: 220,
                    }}
                  >
                    <MenuList className="MuiMenu-list">
                      <MenuItem sx={{ padding: 0 }}>
                        <ButtonAction
                          roles={accesRoles.auditor}
                          disabled={false}
                          action={handleOpenSeguimiento}
                        >
                          <span>Seguimiento de cuentas por provisionar</span>
                        </ButtonAction>
                      </MenuItem>
                      <MenuItem sx={{ padding: 0 }}>
                        <ButtonAction
                          roles={accesRoles.auditor}
                          disabled={false}
                          action={handleNavigateDeductions}
                        >
                          <span>Gestión deducciones</span>
                        </ButtonAction>
                      </MenuItem>
                      <MenuItem sx={{ padding: 0 }}>
                        <ButtonAction
                          roles={accesRoles.auditor}
                          disabled={false}
                          action={handleNavigateCostCenter}
                        >
                          <span>Administrar centro de costo</span>
                        </ButtonAction>
                      </MenuItem>
                    </MenuList>
                  </Paper>
                )}
              </Box>
            </ClickAwayListener>
          </Box>
        </Box>
        {showForm && (
          <>
            <FormFilter
              dataFields={dataFields}
              inputFieldState={inputFieldState}
              getValueDatePickerEnd={getValueDatePickerEnd}
              getValueDatePickerStart={getValueDatePickerStart}
              onChangesDatePicker={onChangesDatePicker}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              handleUserAssignment={handleUserAssignment}
              maxDate={maxDate}
              values={values}
              handleClear={handleClear}
              validateActivitiesSelected={validateActivitiesSelected}
            />
            <ModalStatesPayments
              onCloseModal={onCloseModal}
              openModal={openModalStates}
              paymentStates={statesSelected}
              selectAllActivies={selectAllActivies}
              onSelected={onSelected}
            />
          </>
        )}
        {!showForm && (
          <>
            {hasContract ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "500px",
                }}
              >
                <Typography variant="h6" sx={{ color: "#6d6d6d" }}>
                  Información aun no disponible
                </Typography>
              </Box>
            ) : (
              <>
                <section className={styles.contentTable}>
                  <TableCollapseAutorizations
                    columns={columns}
                    title=""
                    valuesResultsPages={valuesResultsPages}
                    rowSelected={rowSelected}
                    selectAllRows={handleSelectAllClick}
                    selectRow={handleChangeCheck}
                    showBtnGenerateCertificate={showBtnGenerateCertificate}
                    onGenerateCertificate={onGenerateCertificate}
                    classTotalElemnt={width < 500 ? "" : "classTotalElemnt"}
                    providers={providers?.content || null}
                    providersPage={providersPage}
                    providersSize={providersSize}
                    setProvidersPage={setProvidersPage}
                    setProvidersSize={setProvidersSize}
                    totalProviders={providers?.totalElements || 0}
                    contentSizeProviders={providers?.contentSize || 0}
                    providerInvoices={providerInvoices}
                    providerInvoicesPage={providerInvoicesPage}
                    providerInvoicesSize={providerInvoicesSize}
                    providerInvoicesLoading={providerInvoicesLoading}
                    getProviderInvoices={getProviderInvoices}
                    setProviderInvoicesPage={setProviderInvoicesPage}
                    setProviderInvoicesSize={setProviderInvoicesSize}
                    filters={appliedFilters}
                  />
                </section>
                <Box className={styles.containerSummationsRows}>
                  {summationRows.rows.map((item: any, index: any) => (
                    <Box key={item.name} className={styles.contentSummation}>
                      <span>{item.name}: </span>
                      {item.value}
                    </Box>
                  ))}
                </Box>
                {showBtnInitiatePayment && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                      pb: 2,
                    }}
                  >
                    <Button
                      className={styles.authorizationBtnFilters}
                      variant="contained"
                      data-testid="btn-iniciar-proceso-pago"
                      sx={{ minWidth: "220px" }}
                      onClick={() => {
                        const providerName = rowContentSelected?.[0]?.provider;
                        const totalInvoices = rowContentSelected?.length || 0;
                        const totalValue = rowContentSelected?.reduce(
                          (acc: number, row: any) =>
                            acc + (row?.valueEndorsed ?? 0),
                          0,
                        );
                        const nit = rowContentSelected?.[0]?.nit;
                        const paymentLine =
                          rowContentSelected?.[0]?.paymentLine;

                        navigate("/autorizaciones/resumen-proceso-pago", {
                          state: {
                            selectedIds: rowSelected,
                            providerName,
                            totalInvoices,
                            totalValue:
                              totalValue?.toLocaleString?.() ?? totalValue,
                            nit,
                            paymentLine,
                          },
                        });
                      }}
                    >
                      Iniciar proceso de pago
                    </Button>
                  </Box>
                )}
              </>
            )}
          </>
        )}
        {isLoading && <Spinner />}
        <ModalSeguimientoCuentas
          open={openSeguimiento}
          onClose={() => setOpenSeguimiento(false)}
        />
      </section>
    </Layout>
  );
};
